export default {
  scene: {
    background: 0xffbc8d,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 500
    }
  },
  camera: {
    fov: 75,
    near: 1,
    far: 1000,
    position: {
      x: 0,
      y: 50,
      z: 50
    }
  },
  light: {
    color: 0xffffff,
    intensity: 1,
    position: {
      x: 50,
      y: 75,
      z: 75
    }
  }
}
